import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorPlantacionForestalLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="vw_fc001_plantacion_forestal_2025"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/cobertura/E5k/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorPlantacionForestalLayer
